<template>
  <div class="container print-user">
    <b-overlay :show="loading" opacity="0.99">
      <ErrorsMessages :errors="errors" />
      <div v-show="errors.length == 0 && user">
        <div
          class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 content-btn-print d-flex justify-content-end"
        >
          <v-btn class="btn-print" @click="printOut">
            <i class="fas fa-print mr-2 text-twenty"></i> IMPRIMIR
          </v-btn>
        </div>

        <table class="bg-white">
          <thead>
            <div v-if="user.id" class="row">
              <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 pt-1 pb-0">
                <img
                  v-if="rest_home_logo_url"
                  class="rest_home_logo_url"
                  :src="rest_home_logo_url"
                />
                <div v-if="!rest_home_logo_url" class="ml-1">
                  <strong class="text-uppercase">{{ rest_home_name }}</strong>
                </div>
              </div>
              <div class="col-xl-7 col-lg-7 col-md-7 col-sm-7 col-7 pt-1 pb-0">
                <div class="row">
                  <img
                    v-if="user.photo_url"
                    class="user_photo_url"
                    :src="user.photo_url"
                  />
                  <img
                    v-if="!user.photo_url"
                    class="user_photo_url"
                    :src="require('../assets/user.png')"
                  />
                  <div class="ml-5 mt-2">
                    <h6 class="mb-0">{{ user.name }}</h6>
                    <h6 class="mb-0 worksansr upper-text">
                      E-mail: {{ user.email }}
                    </h6>
                    <h6 class="mb-0 worksansr upper-text">
                      Perfil: {{ user.user_profile_name }}
                    </h6>
                    <h6 v-if="user.office" class="mb-0 worksansr upper-text">
                      Cargo: {{ user.office }}
                    </h6>
                  </div>
                </div>
              </div>
              <div
                class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3 pt-1 pb-0 check-text-right"
              >
                <img class="logo" :src="logo" width="180" />
              </div>
            </div>
          </thead>

          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <!-- Informações Pessoais -->
            <div class="row data-inside-avoid">
              <div
                class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0 pb-0 text-center border"
              >
                <h6 class="mb-0">INFORMAÇÕES PESSOAIS</h6>
              </div>
              <div
                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
              >
                <strong>NOME:</strong> {{ user.name }}
              </div>
              <div
                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
              >
                <strong>E-MAIL:</strong> {{ user.email }}
              </div>
              <div
                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
              >
                <strong>CPF:</strong> {{ user.cpf }}
              </div>
              <div
                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
              >
                <strong>TELEFONE:</strong> {{ user.phone }}
              </div>
              <div
                v-if="user.date_of_birth"
                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
              >
                <strong>DATA DE NASCIMENTO:</strong>
                {{ formatDate(user.date_of_birth, false) }}
              </div>
              <div
                v-if="user.nationality"
                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
              >
                <strong>NACIONALIDADE:</strong> {{ user.nationality }}
              </div>
              <div
                v-if="user.city_of_birth"
                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
              >
                <strong>CIDADE DE NASCIMENTO:</strong> {{ user.city_of_birth }}
              </div>
              <div
                v-if="user.mothers_name"
                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
              >
                <strong>NOME DA MÃE:</strong> {{ user.mothers_name }}
              </div>
            </div>

            <!-- Informações Profissionais -->
            <div class="row data-inside-avoid">
              <div
                class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0 pb-0 text-center border"
              >
                <h6 class="mb-0">INFORMAÇÕES PROFISSIONAIS</h6>
              </div>
              <div
                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
              >
                <strong>PERFIL DE USUÁRIO:</strong> {{ user.user_profile_name }}
              </div>
              <div
                v-if="user.office"
                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
              >
                <strong>CARGO/FUNÇÃO:</strong> {{ user.office }}
              </div>
              <div
                v-if="user.professional_class_council_value"
                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
              >
                <strong>CONSELHO PROFISSIONAL:</strong>
                {{ user.professional_class_council_value }}
              </div>
              <div
                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
              >
                <strong>TIPO DE USUÁRIO:</strong>
                {{ user.doctor === 1 ? "MÉDICO" : "OUTROS PROFISSIONAIS" }}
              </div>
              <div
                v-if="user.protocol"
                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
              >
                <strong>PROTOCOLO:</strong> {{ user.protocol }}
              </div>
              <div
                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
              >
                <strong>RESPONSÁVEL TÉCNICO:</strong>
                {{ user.technical_responsible === 1 ? "SIM" : "NÃO" }}
              </div>
            </div>

            <!-- Documentos -->
            <div class="row data-inside-avoid">
              <div
                class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0 pb-0 text-center border"
              >
                <h6 class="mb-0">DOCUMENTOS</h6>
              </div>
              <div
                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
              >
                <strong>CPF:</strong> {{ user.cpf }}
              </div>
              <div
                v-if="user.identity_number"
                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
              >
                <strong>RG:</strong> {{ user.identity_number }}
              </div>
              <div
                v-if="user.national_health_card_number"
                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
              >
                <strong>CARTÃO SUS:</strong>
                {{ user.national_health_card_number }}
              </div>
              <div
                v-if="user.passport_number"
                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
              >
                <strong>PASSAPORTE:</strong> {{ user.passport_number }}
              </div>
              <div
                v-if="user.issuing_country"
                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
              >
                <strong>PAÍS EMISSOR:</strong> {{ user.issuing_country }}
              </div>
            </div>

            <!-- Endereço -->
            <div class="row data-inside-avoid">
              <div
                class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0 pb-0 text-center border"
              >
                <h6 class="mb-0">ENDEREÇO</h6>
              </div>
              <div
                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
              >
                <strong>CEP:</strong> {{ user.cep }}
              </div>
              <div
                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
              >
                <strong>ENDEREÇO:</strong> {{ user.address }},
                {{ user.number_address }}
              </div>
              <div
                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
              >
                <strong>BAIRRO:</strong> {{ user.district }}
              </div>
              <div
                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
              >
                <strong>CIDADE:</strong> {{ user.city }}
              </div>
              <div
                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
              >
                <strong>ESTADO:</strong> {{ user.uf_name }}
              </div>
              <div
                v-if="user.complement"
                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
              >
                <strong>COMPLEMENTO:</strong> {{ user.complement }}
              </div>
            </div>

            <!-- Informações do Sistema -->
            <div class="row data-inside-avoid">
              <div
                class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0 pb-0 text-center border"
              >
                <h6 class="mb-0">INFORMAÇÕES DO SISTEMA</h6>
              </div>
              <div
                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
              >
                <strong>DATA DE CRIAÇÃO:</strong>
                {{ formatDate(user.created_at, false) }}
              </div>
              <div
                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
              >
                <strong>ÚLTIMA ATUALIZAÇÃO:</strong>
                {{ formatDate(user.updated_at, false) }}
              </div>
              <div
                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
              >
                <strong>TERMOS ACEITOS:</strong>
                {{ user.terms === 1 ? "SIM" : "NÃO" }}
              </div>
              <div
                v-if="user.terms_created_at"
                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
              >
                <strong>DATA ACEITE TERMOS:</strong>
                {{ formatDate(user.terms_created_at, false) }}
              </div>
              <div
                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
              >
                <strong>GEOLOCALIZAÇÃO:</strong>
                {{ user.geolocation === 1 ? "HABILITADA" : "DESABILITADA" }}
              </div>
              <div
                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
              >
                <strong>USO DE CERTIFICADO:</strong>
                {{ user.use_certificate === 1 ? "SIM" : "NÃO" }}
              </div>
            </div>

            <!-- Assinatura -->
            <div class="text-center mt-4">
              <p>(Relatório gerado automaticamente)</p>
              <small>{{ moment().format("DD/MM/YYYY HH:mm:ss") }}</small>
            </div>
          </div>
        </table>

        <div
          class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 content-btn-print d-flex justify-content-end"
        >
          <v-btn class="btn-print" @click="printOut">
            <i class="fas fa-print mr-2 text-twenty"></i> IMPRIMIR
          </v-btn>
        </div>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import ErrorsMessages from "../templates/Components/ErrorsMessages";
import api from "../services/api";
import routes from "../routes";
import moment from "moment";
import { formatDate } from "../lib/format";
import { userData } from "../lib/functions";

export default {
  name: "UserPrint",
  components: {
    ErrorsMessages,
  },
  data() {
    return {
      id: "",
      user: null,
      errors: [],
      loading: true,
      rest_home_name: "",
      rest_home_logo_url: null,
      logo: null,
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    moment,
    formatDate,
    async retrieve() {
      const { id } = routes.history.current.params;
      this.id = id;

      const { user: currentUser, logo } = userData();
      this.rest_home_name = currentUser.rest_home_name;
      this.rest_home_logo_url = currentUser.logo_url;
      this.logo = logo;

      await this.get();
    },
    async get() {
      try {
        this.loading = true;
        const { id } = this;
        let params = { id };

        const response = await api.get("/rest-home/user", { params });
        const { user, error, errors } = response.data;

        if (error) {
          this.errors = errors || [];
          if (!user) {
            routes.push({ name: "users" });
            return;
          }
        }

        this.user = user;
        this.loading = false;
      } catch (error) {
        console.log(error);
        this.errors = [{ message: "Erro ao carregar dados do usuário" }];
        this.loading = false;
      }
    },
    printOut: () => window.print(),
  },
};
</script>

<style scoped>
.print-user table {
  width: 100%;
}

.print-user .header {
  position: fixed;
  top: 0;
}

.print-user .logo {
  height: 50px;
  object-fit: contain;
}

.print-user .rest_home_logo_url {
  height: 80px;
  width: 100%;
  object-fit: contain;
}

.print-user .user_photo_url {
  height: 80px;
  width: 80px;
  border-radius: 50%;
  object-fit: cover;
}

.print-user .content-btn-print {
  margin: 20px 0;
}

@media print {
  .print-user table {
    width: 100% !important;
  }

  .print-user button,
  .print-user .content-btn-print {
    display: none !important;
  }

  .print-user .content {
    page-break-inside: avoid !important;
  }

  .print-user .data-inside-avoid {
    page-break-inside: avoid !important;
  }

  .print-user .finish_user {
    font-size: small !important;
  }
}
</style>